import React, { useState, useCallback, useEffect } from "react";
import { Image } from '@fluentui/react';
import {AppMenu} from "./AppMenu";


interface HealthXMProps {}

interface HealthXMState {}

const HealthXM: React.FC<HealthXMProps> = ({}) => {           
    const [pageState, setPageState] = useState<HealthXMState>(() => {});

    return(
       <>
            <div style={{width: "100%", textAlign: "left"}}>
             <AppMenu/>
            </div>
            <div key={'PS11'} style={{ flex: '1 1 calc(100% - 40px)', 
              minHeight: '560px',
              background: 'linear-gradient(145deg, #1a3a5c 0%, #1e4d78 20%, rgba(87, 199, 133, 1) 55%, #f5a623 80%, #ffd166 100%)',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              overflowX: 'hidden',
              padding: '10px'
          }}>
             <div className='card-title'>
               HealthXM
             </div>
             <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
               <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                  {/*<p style={{ textAlign: 'center', fontSize: '14px' }}>{items[currentIndex]}</p>*/}
                  <div className="card-full-grey" style={{minHeight: "450px"}}>         
                    <ul className="card-full-list-grey">
                       <li key="esdxg-program">eSDXG helps businesses to transform its Supply Chain processes using intelligent and autonomous systems. Assist organizations in complex assessments, enable effective decision making and drive outcomes. HealthXM is a program which serve organizations in Health care industry for transformations in R&D, Sales and Procurement functions.</li>
                    </ul>
                  {/*<a href="#" className="card-btn-grey">More..</a>*/}
                    <div style={{fontWeight: 'bold', color: 'blue'}}>HealthXM</div>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', flexWrap: 'wrap' }}>
                      <div style={{ flex: "1 0 calc(40% - 20px)"}}>
                        <Image src="healthxm_model.png" alt="HealthXM" style={{ minWidth: '300px', width: '80%', height: '80%'}} />
                      </div>
                      <div style={{ flex: "1 1 calc(60% - 20px)", overflowY: "auto"}}>
                        <ul className="card-list-grey">
                          <li key="healthxm-feature1">Assisting industry players to streamline their commercial operations.</li>
                          <li key="healthxm-feature2">Works with Pharma & Life science companies and leverage platform features in studies and trials to improve efficiency, timelines and drive innovation.</li>
                          <li key="healthxm-feature3">Improve patient engagement and experience through insightful actions in both clinical diagnostics and therapeutics.</li>
                          <li key="healthxm-feature4">Enabling sales across the value chain.</li>
                          <li key="healthxm-feature5">Intelligent inventory planning and procurement.</li>                      
                        </ul>
                    </div>                    
                    </div>
                    <div style={{color: 'blue', fontStyle: 'italic', fontSize: '1.1rem'}}>
                      Do you think your current business strategy is competitive? Please send your enquiries for details on how we can help at services@esdxg.com.
                    </div>
                    </div>                                        
                </div>
            </div>            
        </div>
        </>
    );
}

export default HealthXM; 
